// import React, { useContext, useState, useEffect } from 'react';
// import { useForm } from 'react-hook-form';
// import { toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';
// import { Context } from '../../../index';
// import Autocomplete from './UseAutoComplete';
// import kommuner from '../kommuner.json';
// import { Toggle } from "../../../UI/ToggleButton/Toggle";
// import { Toggle4 } from "../../../UI/ToggleButton/Toggle4";
// import './styles.css';
//
// type FormValues = {
//     name: string;
//     city: string;
//     category: string[];
// };
//
// // @ts-ignore
// const PopUpMessage = ({ message, onClose }) => (
//     <div className={'mb-32'}>
//         <div className="popup2 center m-32 pb-48">
//             <div className="popup-inner m-16 pt-64">
//                 <h3>{message}</h3>
//                 <button className={'ghostbutton mt-16'} onClick={onClose}>Jag förstår</button>
//             </div>
//         </div>
//     </div>
// );
//
// export default function RegisterStudentGmail() {
//     const { register, handleSubmit, setValue, formState: { errors }, setError, clearErrors, watch } = useForm<FormValues>();
//     const [name, setName] = useState<string>('');
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();
//     const { store } = useContext(Context);
//     const [showPopUp, setShowPopUp] = useState(false);
//     const [categories, setCategories] = useState<string[]>([]);
//     const [toggleState, setToggleState] = useState(false);
//     const [toggle4State, setToggle4State] = useState(false);
//     const [toggle5State, setToggle5State] = useState(false);
//
//     const cityValue = watch('city');
//
//     useEffect(() => {
//         if (errors.name) toast.error(errors.name.message);
//         if (errors.city) toast.error(errors.city.message);
//         if (errors.category) toast.error(errors.category.message);
//     }, [errors]);
//
//     const handleToggleChange = () => {
//         const newToggleState = !toggleState;
//         setToggleState(newToggleState);
//         updateCategories('CategoryB', newToggleState);
//     };
//
//     const handleToggleChange4 = () => {
//         const newToggle4State = !toggle4State;
//         setToggle4State(newToggle4State);
//         updateCategories('CategoryA', newToggle4State);
//         if (newToggle4State) setShowPopUp(true);
//     };
//
//     const handleToggleChange5 = () => {
//         const newToggle5State = !toggle5State;
//         setToggle5State(newToggle5State);
//         updateCategories('No category', newToggle5State);
//     };
//
//     const updateCategories = (category: string, add: boolean) => {
//         const updatedCategories = add
//             ? [...categories, category]
//             : categories.filter((cat) => cat !== category);
//
//         setCategories(updatedCategories);
//
//         if (updatedCategories.length > 0) clearErrors('category');
//     };
//
//     const handleClick = () => {
//         navigate('/login')
//     }
//
//     const onSubmit = (data: FormValues) => {
//         const { name, city = '' } = data;
//
//         // Retrieve studentId from sessionStorage
//         const user = JSON.parse(sessionStorage.getItem('user') || '{}');
//         const studentId = user.id;
//
//         // Check if city is valid by comparing it to the list of cities in kommuner.json
//         if (!kommuner.includes(city)) {
//             setError('city', { type: 'manual', message: 'Vänligen välj en giltig kommun från listan' });
//             return;
//         }
//
//         if (categories.length === 0) {
//             setError('category', { type: 'manual', message: 'Vänligen välj din kategori' });
//             return;
//         }
//
//         setLoading(true);
//
//         // @ts-ignore
//         store.registrationG(name, city, studentId,  categories,) // Pass studentId to the registration method
//             // @ts-ignore
//             .then((response) => {
//                 setLoading(false);
//                 // @ts-ignore
//                 if (response.status === 200) {
//                     toast.success(`Tack! Ditt konto är nu skapad.`);
//                     handleClick();
//
//                 } else {
//                     // @ts-ignore
//                     if (response.status === 400 || response.status === 500) {
//                         toast.error("Something went wrong. Please try again.");
//                     }
//                 }
//             })
//             .catch(() => {
//                 setLoading(false);
//                 toast.error("Registration failed. Please try again later.");
//             });
//     };
//
//     return (
//         <>
//             <div className='center pt-32' style={{ maxWidth: 350 }}>
//                 <div className='center pb-32 pt-32'>
//                     <h3 className='pt-32 p-16'>Berätta lite mer om dig</h3>
//                     <h4 className='pt-32 p-16'></h4>
//                 </div>
//
//                 {showPopUp && (
//                     <PopUpMessage
//                         message="Tyvärr har vi ingen övningskort på det kategori just nu, men vi jobbar på det."
//                         onClose={() => setShowPopUp(false)}
//                     />
//                 )}
//
//                 <form onSubmit={handleSubmit(onSubmit)}>
//                     <label>Välj din körkortskategorin </label>
//                     <div className='container center p-32'>
//                         <Toggle toggle={toggleState} handleToggleChange={handleToggleChange} />
//                         <Toggle4 toggle4={toggle4State} handleToggleChange4={handleToggleChange4} toggle5={toggle5State} handleToggleChange5={handleToggleChange5} />
//                     </div>
//                     {errors?.category && (
//                         <p className='description error pt-32'>{errors.category.message}</p>
//                     )}
//                     <div>
//
//                         <label>Skriv din kommun och välj en i listan nedan </label>
//                         <Autocomplete
//                             suggestions={kommuner.map((city) => city)}
//                             onSelect={(selectedCity) => {
//                                 setValue('city', selectedCity || '');
//                                 if (selectedCity.trim()) {
//                                     clearErrors('city');
//                                 }
//                             }}
//                             value={cityValue || ''}
//                             onChange={(value) => {
//                                 setValue('city', value || '');
//                             }}
//                         />
//
//                         {errors?.city && <p className='description error'>{errors.city.message}</p>}
//
//                         <label>Vill du uppdatera ditt namn?</label>
//                         <input
//                             {...register('name', {
//                                 minLength: {
//                                     value: 2,
//                                     message: 'Ditt namn kan inte vara kortare än två bokstäver',
//                                 },
//                             })}
//                             type='text'
//                             onChange={(e) => setName(e.target.value)}
//                             placeholder='Skriv ditt namn här'
//                             className={"mt-8"}
//                         />
//                         {errors?.name &&
//                             <p className='description error'>{errors.name.message}</p>
//                         }
//
//                     </div>
//                     <button type='submit' className='button mt-32' disabled={loading}>
//                         {loading ? 'Registrerar...' : 'Slutför registrering'}
//                     </button>
//                 </form>
//             </div>
//         </>
//     );
// }


import React, { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Context } from '../../../index';
import Autocomplete from './UseAutoComplete';
import kommuner from '../kommuner.json';
import { Toggle } from "../../../UI/ToggleButton/Toggle"; // Your custom Toggle
import { Toggle4 } from "../../../UI/ToggleButton/Toggle4";
import './styles.css';
import { FaCar, FaCog, FaMapMarkerAlt, FaUser } from 'react-icons/fa'; // Import new icons
import {Manuell} from "../../../UI/ToggleButton/Manuell";
import {AutoTransmission} from "../../../UI/ToggleButton/AutoTransmission";

type FormValues = {
    name: string;
    city: string;
    category: string[];
    autotransmission: boolean; // Add autotransmission to form values
};

// @ts-ignore
const PopUpMessage = ({ message, onClose }) => (
    <div className={'mb-32'}>
        <div className="popup2 center m-32 pb-48">
            <div className="popup-inner m-16 pt-64">
                <h3>{message}</h3>
                <button className={'ghostbutton mt-16'} onClick={onClose}>Jag förstår</button>
            </div>
        </div>
    </div>
);

export default function RegisterStudentGmail() {
    const { register, handleSubmit, setValue, formState: { errors }, setError, clearErrors, watch } = useForm<FormValues>();
    const [name, setName] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { store } = useContext(Context);
    const [showPopUp, setShowPopUp] = useState(false);
    const [categories, setCategories] = useState<string[]>([]);
    const [toggleState, setToggleState] = useState(false);
    const [toggle4State, setToggle4State] = useState(false);
    const [toggle5State, setToggle5State] = useState(false);
    const [isManuellActive, setIsManuellActive] = useState(false);
    const [isAutomatActive, setIsAutomatActive] = useState(false);

    const cityValue = watch('city');


    const handleToggleChange = () => {
        const newToggleState = !toggleState;
        setToggleState(newToggleState);
        updateCategories('CategoryB', newToggleState);
    };

    const handleToggleChange4 = () => {
        const newToggle4State = !toggle4State;
        setToggle4State(newToggle4State);
        updateCategories('CategoryA', newToggle4State);
        if (newToggle4State) setShowPopUp(true);
    };

    const handleToggleChange5 = () => {
        const newToggle5State = !toggle5State;
        setToggle5State(newToggle5State);
        updateCategories('No category', newToggle5State);
    };

    const handleManuellSelect = () => {
        setIsManuellActive(true);
        setIsAutomatActive(false);
        setValue('autotransmission', false);
        clearErrors('autotransmission'); // Clear the transmission error
    };

    const handleAutomatSelect = () => {
        setIsManuellActive(false);
        setIsAutomatActive(true);
        setValue('autotransmission', true);
        clearErrors('autotransmission'); // Clear the transmission error
    };

    const updateCategories = (category: string, add: boolean) => {
        const updatedCategories = add
            ? [...categories, category]
            : categories.filter((cat) => cat !== category);

        setCategories(updatedCategories);

        if (updatedCategories.length > 0) clearErrors('category');
    };

    const handleClick = () => {
        navigate('/login')
    }


    const onSubmit = (data: FormValues) => {
        const { name, city = '', autotransmission } = data; // Include autotransmission
        const allErrors: string[] = [];

        if (categories.length === 0) {
            allErrors.push('Vänligen välj din körkortskategori');
            setError('category', { type: 'manual', message: 'Vänligen välj din körkortskategori' });
        } else {
            clearErrors('category'); // Clear error if it was previously set
        }

        if (!isManuellActive && !isAutomatActive) {
            allErrors.push('Vänligen välj växellåda');
            setError('autotransmission', { type: 'manual', message: 'Vänligen välj växellåda' });
        } else {
            clearErrors('autotransmission'); // Clear error if it was previously set
        }

        if (!city.trim()) {
            allErrors.push('Vänligen ange din kommun');
            setError('city', { type: 'manual', message: 'Vänligen ange din kommun' });
        } else if (!kommuner.includes(city)) {
            allErrors.push('Vänligen välj en giltig kommun från listan');
            setError('city', { type: 'manual', message: 'Vänligen välj en giltig kommun från listan' });
        } else {
            clearErrors('city'); // Clear error if it was previously set
        }

        if (allErrors.length > 0) {
            toast.error('Vänligen kontrollera uppgifterna');
            return; // Stop the submission if there are errors
        }

        setLoading(true);

        // Retrieve studentId from sessionStorage
        const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        const studentId = user.id;

        // @ts-ignore
        store.registrationG(name, city, studentId,  categories, autotransmission) // Pass autotransmission
            // @ts-ignore
            .then((response) => {
                setLoading(false);
                // @ts-ignore
                if (response.status === 200) {
                    toast.success(`Tack! Ditt konto är nu skapad.`);
                    handleClick();

                } else {
                    // @ts-ignore
                    if (response.status === 400 || response.status === 500) {
                        toast.error("Something went wrong. Please try again.");
                    }
                }
            })
            .catch(() => {
                setLoading(false);
                toast.error("Registration failed. Please try again later.");
            });
    };


    // @ts-ignore
    return (
        <div className='pt-64 m-16'>
            <div className='center' style={{ maxWidth: 600, backgroundColor: 'rgba(226,225,225,0.22)', borderRadius: '10px' }}>
                <div className='center pb-32 pt-32 '>
                    <h3>Vi behöver lite mer uppgifter om dig</h3>
                </div>

                {showPopUp && (
                    <PopUpMessage
                        message="Tyvärr har vi ingen övningskort på det kategori just nu, men vi jobbar på det."
                        onClose={() => setShowPopUp(false)}
                    />
                )}

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="pt-16 pb-32">
                        <FaCar className="icon2" />
                        <div className='font2'>Välj din körkortskategorin </div>
                    </div>
                    <div className='container center pb-32'>
                        <Toggle toggle={toggleState} handleToggleChange={handleToggleChange} />
                        <Toggle4 toggle4={toggle4State} handleToggleChange4={handleToggleChange4} toggle5={toggle5State} handleToggleChange5={handleToggleChange5} />
                    </div>
                    {errors?.category && (
                        <p className='description error pt-8'>{errors.category.message}</p>
                    )}

                    <div className="pb-32 pt-16    ">
                        <FaCog className="icon2" />
                        <div className='font2'>Växellåda </div>
                    </div>

                    <div className='container center pb-32'>
                        <Manuell
                            toggle={isManuellActive}
                            handleToggleChange={handleManuellSelect}
                        >
                        </Manuell>
                        <AutoTransmission
                            toggle={isAutomatActive}
                            handleToggleChange={handleAutomatSelect}
                        >
                        </AutoTransmission>
                    </div>
                    {errors?.autotransmission && <p className='description error pt-8'>{errors.autotransmission.message}</p>}


                    <div className="pt-16">
                        <FaMapMarkerAlt className="icon2" />
                        <div className='font2'>Skriv din kommun och välj en i listan nedan </div>
                    </div>

                    <div className='center' style={{maxWidth: '290px'}}>
                        <Autocomplete
                            suggestions={kommuner.map((city) => city)}
                            onSelect={(selectedCity) => {
                                setValue('city', selectedCity || '');
                                if (selectedCity.trim()) {
                                    clearErrors('city');
                                }
                            }}
                            value={cityValue || ''}
                            onChange={(value) => {
                                setValue('city', value || '');
                            }}
                        />
                    </div>
                    {errors?.city && <p className='description error'>{errors.city.message}</p>}

                    <div className="pt-16">
                        <FaUser className="icon2" />
                        <div className='font2 pb-8'>Vill du uppdatera ditt namn?</div>
                        <input
                            {...register('name', {
                                minLength: {
                                    value: 2,
                                    message: 'Ditt namn kan inte vara kortare än två bokstäver',
                                },
                            })}
                            type='text'
                            onChange={(e) => setName(e.target.value)}
                            placeholder='Skriv ditt namn här'
                            style={{maxWidth: '290px'}}
                        />
                        {errors?.name &&
                            <p className='description error'>{errors.name.message}</p>
                        }
                    </div>
                    <button type='submit' style={{maxWidth: 240}} className='button mt-32' disabled={loading}>
                        {loading ? 'Registrerar...' : 'Slutför registrering'}
                    </button>
                </form>
            </div>
        </div>
    );
}